import { Avatar, Box, CardMedia, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomSelect from "../../../components/Select/Select";
import { getDiagnosticDashboardData } from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { diagnosticsStatusList } from "../../../util/arrayList";
import { getWeekRange } from "../../../util/function";

const defaultSelected = { name: "All", value: "all" };

const LabDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("today");
  const [weekDate, setWeekDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedStatus, setSelectedStatus] = useState(defaultSelected);
  const { diagnosticDashboard } = useSelector((state) => state?.clinic);
  const profile = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    onApiCall();
  }, []);

  const onApiCall = (status = null) => {
    let url = `&doctorId=${profile?.id}`;
    if (status) {
      url = `${url}&status=${status}`;
    }
    dispatch(
      getDiagnosticDashboardData({
        type: "all",
        //  "Outpatient"
        url,
      })
    );
  };

  const handleCardClick = (appointment) => {
    navigate("/lab-pet-details", {
      state: { appointment },
    });
  };

  const getGroomAppointments = () => {
    return diagnosticDashboard?.flatMap((item) =>
      item?.diagnostic?.map((diag) => ({
        diagnostic: diag,
        appoinment: item?.appointment,
      }))
    );
  };

  const handleSelectWeek = () => {
    setWeekDate(getWeekRange(new Date())?.startDate);
    setSelectedType("week");
  };

  const handleSelectToday = () => {
    setSelectedType("today");
    setSelectedDate(new Date());
  };

  const handleDateChange = (value) => {
    const reqDate = new Date(selectedDate);
    reqDate.setDate(
      value === "add" ? reqDate.getDate() + 1 : reqDate.getDate() - 1
    );
    setSelectedDate(reqDate);
    setSelectedType(
      moment(reqDate).format("YYYY-MM-DD") ===
        moment(new Date()).format("YYYY-MM-DD")
        ? "today"
        : null
    );
  };

  const handleWeekChange = (value) => {
    if (value === "add") {
      setWeekDate(getWeekRange(weekDate, 1).startDate);
    } else {
      setWeekDate(getWeekRange(weekDate, -1).startDate);
    }
  };

  return (
    <>
      <div
        className="flex-row-ali-cen back-white"
        style={{ padding: "12px 24px" }}
      >
        <div className="ph10pv3">
          <div className={`flex-center cursor pet-det-sel-tab`}>
            Lab Appointments
          </div>
        </div>
        <div className="flex1-end">
          <div className="w20Per">
            <CustomSelect
              list={diagnosticsStatusList}
              value={selectedStatus}
              handleChange={(e, value) => {
                if (value?.value === "all") {
                  onApiCall();
                } else {
                  onApiCall(value?.value);
                }
                setSelectedStatus(value);
              }}
              search
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
        </div>
      </div>

      {/* <div className="flex-row-ali-cen mh30 mt20">
        <div className="w20Per">
          <div className="flex-row-ali-cen">
            <Typography
              className={`font-bold fs14 cursor day-type-box ${
                selectedType === "today" ? "black" : "gray2"
              }`}
              onClick={handleSelectToday}
            >
              Today
            </Typography>
            <Typography
              className={`font-bold fs14 cursor day-type-box ${
                selectedType === "week" ? "black" : "gray2"
              }`}
              onClick={handleSelectWeek}
            >
              Week
            </Typography>
          </div>
        </div>
        <div className="w60Per">
          <div className="flex1-center">
            <div className="flex-row">
              <div className="flex-center">
                <NavigateBeforeOutlinedIcon
                  className="calendar-arrow cursor"
                  onClick={() =>
                    selectedType !== "week"
                      ? handleDateChange("minus")
                      : handleWeekChange("minus")
                  }
                />
                <Typography className="text-bold mh20">
                  {selectedType === "week"
                    ? `${moment(
                        new Date(getWeekRange(weekDate)?.startDate)
                      ).format("DD MMM")} - ${moment(
                        new Date(getWeekRange(weekDate)?.endDate)
                      ).format("DD YYYY")}`
                    : moment(new Date(selectedDate)).format("DD MMM YYYY")}
                </Typography>
                <NavigateNextOutlinedIcon
                  className="calendar-arrow cursor"
                  onClick={() =>
                    selectedType !== "week"
                      ? handleDateChange("add")
                      : handleWeekChange("add")
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w20Per">
          <div className="flex-end">
            <div className="w70Per">
              <CustomSelect
                list={[{ name: "All", value: "all" }, ...diagStatusList]}
                value={selectedStatus}
                handleChange={(e) => setSelectedStatus(e?.target?.value)}
                select
              />
            </div>
          </div>
        </div>
      </div> */}

      <Box className="pb-40 ph20">
        {/* Header */}
        <div className="flex-row-ali-cen">
          <div className="w10Per flex-center">
            <Typography className="txt-semi-bold fs16 blue-color">
              Time
            </Typography>
          </div>
          <div className="w90Per" />
        </div>
        {/* Appointments List */}
        <div className="mt20 scroll-70vh">
          {getGroomAppointments()?.map((itm, index) => {
            const apnt = itm?.appoinment;
            // Create unique key combining appointmentId and diagnostic ID (or index)
            const uniqueKey = `${apnt?.appointmentId}-${
              itm?.diagnostic?.diagonosticId || index
            }`;
            return (
              <div key={uniqueKey} className="flex-row-ali-cen mb10">
                <div className="w10Per flex-center">
                  <div className="flex-center br5 txt-regular fs16 tim-con">
                    {moment(apnt?.appointmentdateTime).format("HH.mm")}
                  </div>
                </div>

                {/* Appointment Card */}
                <div className="w90Per pl20">
                  <div className="flex-row-ali-cen br15 lght-blu-bck-con">
                    {/* Pet Information */}
                    <div
                      className="flex-row-ali-cen w30Per cursor"
                      style={{ alignItems: "stretch" }}
                      onClick={() => handleCardClick(itm)}
                    >
                      <div
                        style={{
                          background: "#6d79fc",
                          width: 10,
                        }}
                        className="brl10"
                      />
                      <div className="ali-slf-cen pv10 ml5">
                        {apnt?.petImage ? (
                          <CardMedia
                            image={apnt?.petImage}
                            className="h50img ml5"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {apnt?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>

                      <div className="ml10 pv10">
                        <div className="flex-row">
                          <Custom3dotString
                            str={apnt?.petName}
                            className="txt-semi-bold fs14"
                            length={30}
                          />
                          <Typography
                            className={`txt-regular ml3 capitalize ${
                              apnt?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            ({apnt?.gender})
                          </Typography>
                        </div>
                        <Typography className="txt-regular card-black1 fs12 capitalize">
                          {apnt?.breed}
                        </Typography>
                        <div className="flex-row mt5">
                          <div className="flex-start">
                            <div className="flex-center">
                              <Avatar
                                src="/broken-image.jpg"
                                sx={{ width: 20, height: 20 }}
                              />
                            </div>
                          </div>
                          <div className="ml5 flex-center">
                            <Custom3dotString
                              str={apnt?.userName ?? ""}
                              className="font-bold fs12"
                              length={30}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Service Details */}
                    <div
                      className="flex-row-ali-cen w50Per"
                      style={{ alignItems: "stretch" }}
                    >
                      <div className="ver-bar-auto" />
                      <div className="ml10">
                        <div className="flex-row-ali-cen">
                          <Typography className="font-bold fs14 black">
                            {apnt?.serviceType}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="txt-semi-bold fs14 gray20 mt5">
                            {apnt?.serviceNames
                              ?.flat(Infinity)
                              ?.map((item) => item?.serviceName)
                              ?.join(", ")}
                          </Typography>
                        </div>
                        <Typography className="txt-regular fs12 black26 mt5">
                          {apnt?.remarks}
                        </Typography>
                      </div>
                    </div>

                    {/* Status/Actions */}
                    <div className="w20Per">
                      <div className="flex-row-ali-cen">
                        <img
                          src={require(`../../../assets/images/png/${
                            itm?.diagnostic?.status?.toLowerCase() ===
                            "in progress"
                              ? "infoBle.png"
                              : itm?.diagnostic?.status?.toLowerCase() ===
                                "pending approval"
                              ? "clkYel.png"
                              : itm?.diagnostic?.status?.toLowerCase() ===
                                "completed"
                              ? "tick.png"
                              : itm?.diagnostic?.status?.toLowerCase() ===
                                "cancelled"
                              ? "crossRed.png"
                              : "calOrg.png"
                          }`)}
                          className="img-wh15"
                        />
                        <Typography className="font-medium fs12 black27 ml5">
                          {itm?.diagnostic?.status?.toLowerCase() ===
                          "in progress"
                            ? "Processing"
                            : itm?.diagnostic?.status}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Box>
    </>
  );
};

export default LabDashboard;
